module.exports = __webpack_public_path__ + "guide-notice03.e60c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-notice03.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-notice03.svg
// module chunks = main